import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { WebCompany, WebCustomer } from "../../models"
import { ErrorDialogComponent } from "src/app/components/error-dialog/error-dialog.component";
import { Subscription } from "rxjs";
import { MatDialog } from "@angular/material/dialog";
import { ConfirmSetPwDialogComponent } from "./confirm-set-pw-dialog/confirm-set-pw-dialog.component";
import { PasswordUpdate } from "../../models/password-update";
import { CustomerService, AuthService, SharedService, CompanyService } from "../../services";
import { AccountClient } from "../../models";
import { NgForm } from "@angular/forms";
import { AlertDialogComponent } from "src/app/components/alert-dialog/alert-dialog.component";
import { filter } from "rxjs/operators";

@Component({
  selector: "app-set-password",
  templateUrl: "./set-password.component.html",
  styleUrls: ["./set-password.component.scss"],
})
export class SetPasswordComponent implements OnInit, OnDestroy
{

  public passwordRequirements;
  public doesPasswordMeetRequirements: boolean;
  public passwordError: string;
  public customerSubscription: Subscription;
  public customer: WebCustomer;

  public companySubscription: Subscription;
  public company: WebCompany;

  public originalPasswordUpdate: PasswordUpdate = {};

  public passwordUpdate: PasswordUpdate = { ...this.originalPasswordUpdate };

  alertMessage: string;
  inputValue: string;
  isNewPasswordValid: boolean = false;
  errorString: any;
  hideNewPassword: boolean;
  hideConfirmNewPassword: boolean;
  validRequirements = new Set<string>();
  private readonly currentState = {
    isTemp: false,
    passwordOkay: false
  };

  isTempPassword: boolean;
  showSpinner: boolean = false;


  constructor(
    public router: Router,
    public changeDetection: ChangeDetectorRef,
    private customerService: CustomerService,
    private companyService: CompanyService,
    private sharedService: SharedService,
    private accountClient: AccountClient,
    private authService: AuthService,
    public dialog: MatDialog,

  )
  {
    this.currentState = history?.state?.data;
  }

  ngOnInit(): void
  {
    this.customerSubscription = this.customerService.customer.subscribe(customer =>
    {
      this.customer = customer;
    });

    this.companySubscription = this.companyService.company.subscribe(company =>
    {
      this.company = company;
      this.setPasswordInfo();
    });

    this.isTempPassword = this.currentState?.isTemp;
    this.doesPasswordMeetRequirements = this.currentState?.passwordOkay;

  }

  setPasswordInfo()
  {
    this.showSpinner = false;
    this.changeDetection.detectChanges();
    if (this.company?.Version?.startsWith("10.02"))
    {
      this.accountClient.getPasswordRequirements().subscribe(p => 
      {
        if (p)
        {
          this.passwordRequirements = p;
        }
        else
        {
          this.alertMessage = ("There was a problem loading the password requirements. Please try again later.")
          this.alertDialog(this.alertMessage)
        }
      });
    }
    else
    {
      this.accountClient.getPasswordRequirementsV2().subscribe(p =>
      {
        if (p)
        {
          this.passwordRequirements = p;
        }
        else
        {
          this.alertMessage = ("There was a problem loading the password requirements. Please try again later.")
          this.alertDialog(this.alertMessage)
        }
      });
    }
  }

  validateInput(password: string): void
  {
    this.validRequirements.clear();
    if (!password)
    {
      return;
    }
    for (const requirement in this.passwordRequirements)
    {
      if (this.passwordRequirements?.hasOwnProperty(requirement))
      {
        const regex = new RegExp(this.passwordRequirements[requirement]);
        const match = regex.test(password);
        if (match)
        {
          this.validRequirements.add(requirement);
        }
      }
    }
    const requirementSize = Object.keys(this.passwordRequirements).length;
    this.isNewPasswordValid = this.validRequirements.size === requirementSize;
    if(this.isNewPasswordValid)
    {
      this.passwordUpdate.NewPassword = password;
    }
    else
    {
      return;
    }
    
  }

  submitPasswordUpdate(form: NgForm)
  {
    if (!form.valid)
    {
      if (!this.passwordUpdate.NewPassword || !this.passwordUpdate.ConfirmPassword)
      {
        this.alertMessage = "Please ensure all fields are filled in correctly."
        this.alertDialog(this.alertMessage);
      }
    }
    else if (this.passwordUpdate.NewPassword != this.passwordUpdate.ConfirmPassword && this.isNewPasswordValid)
    {
      this.alertMessage = "Your confirmation password does not match your new password."
      this.alertDialog(this.alertMessage);
    }
    else if (!this.isNewPasswordValid)
    {
      this.alertMessage = "Your password does not meet the requirements shown below."
      this.alertDialog(this.alertMessage);
    }
    else
    {
      this.showSpinner = true;
      this.changeDetection.detectChanges();
      this.passwordUpdate.OldPassword = this.sharedService.tempPassword;
      this.customerService.updatePassword(this.customer.CustId, this.customer.AcctNo, this.passwordUpdate.OldPassword, this.passwordUpdate.NewPassword)
        .subscribe(r =>
        {
          if (r)
          {
            this.customerService.populateData();
            this.confirmUpdate();
          }
          else 
          {
            this.errorDialog("Please try again.")
          }
        }, error =>
        {
          this.errorDialog(error);
        });
    }
  }

  alertDialog(message)
  {
    this.showSpinner = false;
    this.dialog.open(AlertDialogComponent, {
      panelClass: "form-field-less-than-180",
      width: "500px",
      height: "200px",
      data: {
        title: "Invalid form",
        message: message, buttonText: "Close"
      }
    });
  }

  errorDialog(error)
  {
    this.showSpinner = false;
    const dialogRef = this.dialog.open(ErrorDialogComponent, {
      panelClass: "form-field-less-than-180",
      maxWidth: "600px",
      maxHeight: "500px",
      disableClose: true,
      data: "There was an error updating your password. " + error
    });

    dialogRef.afterClosed().subscribe(_ =>
    {
      this.customerService.populateData();
      this.authService.logoutRedirect();
    });
  }

  confirmUpdate()
  {
    this.showSpinner = false;
    const dialogRef = this.dialog.open(ConfirmSetPwDialogComponent, {
      panelClass: "form-field-less-than-180",
      maxWidth: "600px",
      maxHeight: "500px",
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe(_ =>
    {
      this.dialog.closeAll();
      this.router.navigate(["/home"]);
    });
  }

  ngOnDestroy()
  {
    this.customerSubscription.unsubscribe();
    this.companySubscription.unsubscribe();
  }
}
